module.exports = __webpack_public_path__ + "img/back-jobmule.767b97b7.png";